import { useContext, useEffect, useReducer } from "react"
import { useTranslation } from "react-i18next"
import BannerContext, { BannerReducer, initialState } from "./context"
import { Banner, BannerContent, BannerIconContainer, Container } from "./styles"
import { ReactComponent as AlertIcon } from "assets/icons/exclamation.svg"
import { BannerChannel } from "./utils"
import { useAuth } from "providers/auth"

const BannerProvider: React.FC = ({ children }) => {
  const [bannerState, dispatch] = useReducer(
    BannerReducer,
    BannerReducer(initialState, localStorage.getItem("environment-banner"))
  )
  const { user } = useAuth()

  return (
    <BannerContext.Provider value={{ bannerState, dispatch }}>
      <Container>
        {!!user && <EnvironmentBanner />}
        {children}
      </Container>
    </BannerContext.Provider>
  )
}

export const EnvironmentBanner: React.FC = () => {
  const { bannerState, dispatch } = useContext(BannerContext)
  const { t } = useTranslation("translation")

  useEffect(() => {
    const bannerChannel = new BroadcastChannel(BannerChannel.Name)
    bannerChannel.onmessage = (event) => {
      if (event.data === BannerChannel.DevelopmentEvent) {
        dispatch("development")
      }
      if (event.data === BannerChannel.LocalEvent) {
        dispatch("local")
      }
      if (event.data === BannerChannel.StagingEvent) {
        dispatch("staging")
      }
      if (event.data === BannerChannel.MaintenanceEvent) {
        dispatch("maintenance")
      }
      if (event.data === BannerChannel.ProductionEvent) {
        dispatch("production")
      }
    }
    return () => bannerChannel.close()
  }, [])

  if (!bannerState.visible) {
    return null
  }
  return (
    <Banner color={bannerState.color} background={bannerState.background}>
      <BannerContent>
        <BannerIconContainer>
          <AlertIcon />
        </BannerIconContainer>
        {t(bannerState.content)}
      </BannerContent>
    </Banner>
  )
}

export default BannerProvider
